import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyAlphabets]',
  standalone: false,
})
export class OnlyAlphabetsDirective {
  key: any;
  @HostListener('keydown', ['$event']) onKeydown(event: KeyboardEvent) {
    this.key = event.keyCode;
    if (
      !(
        this.key == 8 ||
        this.key == 9 ||
        this.key == 32 ||
        this.key == 46 ||
        (this.key >= 37 && this.key <= 40) ||
        (this.key >= 65 && this.key <= 90)
      )
    ) {
      event.preventDefault();
    }
  }
}
